import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import styles from './styles.module.scss';

const DEFAULT_BUTTON_TEXT = 'Find out more';

const SeasonOffers = ({ offers = [] }) => {
    if (!offers?.length) {
        return null;
    }

    return (
        <div className={styles.seasonOffers}>
            <div className={styles.offerGrid}>
                {offers.map(
                    (
                        { title, description, image, link, buttonText = DEFAULT_BUTTON_TEXT },
                        index
                    ) => (
                        <Link
                            to={link}
                            className={styles.offerTile}
                            key={`${title}-${index}`}
                        >
                            {image?.childImageSharp?.fluid && (
                                <Img
                                    className={styles.offerImage}
                                    fluid={image.childImageSharp.fluid}
                                    alt={title}
                                />
                            )}
                            <div className={styles.offerOverlay} />
                            <div className={styles.offerContent}>
                                <h3 className={styles.offerTitle}>{title}</h3>
                                {!!description && (
                                    <p className={styles.offerDescription}>{description}</p>
                                )}
                                <span className={styles.offerLink}>{buttonText}</span>
                            </div>
                        </Link>
                    )
                )}
            </div>
        </div>
    );
};

export default SeasonOffers;
